import { cva } from '@/styled-system/css';

export const progressStepperStepsRecipe = cva({
  base: {
    display: 'flex',
    listStyle: 'none',
    width: '100%',
  },
  variants: {
    orientation: {
      horizontal: {},
      vertical: {
        display: 'grid',
        gridTemplateRows: 'repeat(var(--c11n-steps), minmax({sizes.handle.sm}, 1fr)) auto',
      },
    },
  },
});
